import { useEffect } from "react";
import { useFetch } from "use-http";

/**
 *
 * Fetch template YAML
 */
export default function useTemplate(id?: string) {
  const { get, data: yaml, loading } = useFetch<string>();

  useEffect(() => {
    if (id) {
      get(`/pipelines/playground/templates/${id}`);
    }
  }, [id]);

  return { yaml, loading };
}
